import type { TOrganizationProgressStep } from 'types/kinerja-pelaksanaan'

export const ORGANIZATION_PROGRESS_STEPS: Record<
  TOrganizationProgressStep,
  { title: string; description: string | React.ReactNode; order: number }
> = {
  STEP_PREDICATE_RECOMMENDATION: {
    title: 'Pengiriman data Penilaian Kinerja ke Dinas Pendidikan',
    description:
      'Dilakukan setelah seluruh Pegawai selesai dinilai. Pengiriman bukan tahap akhir dan dilakukan hanya agar Predikat Kinerja Organisasi dapat diproses.',
    order: 1,
  },
  STEP_ORGANIZATION_PREDICATE: {
    title: 'Predikat Kinerja Organisasi sedang diproses',
    description:
      'Predikat akan ditetapkan berdasarkan rekomendasi dari Kemendikbudristek bersama Dinas Pendidikan.',
    order: 2,
  },
  STEP_EMPLOYEE_PREDICATE: {
    title: 'Penetapan Predikat Kinerja Pegawai',
    description: (
      <>
        Ini adalah <strong>tahap akhir</strong> yang dilakukan untuk Penilaian
        Kinerja. Penetapan dilakukan berdasarkan Predikat Kinerja Organisasi.
      </>
    ),
    order: 3,
  },
  STEP_DOCUMENT_EVALUATION: {
    title: 'Penerimaan Dokumen Evaluasi Kinerja',
    description:
      'Dokumen Evaluasi Kinerja Pegawai untuk periode yang sedang berlangsung akan diterima oleh masing-masing Pegawai.',
    order: 4,
  },
}
